module.exports = __webpack_public_path__ + "img/master-card.4e17199f.svg";